import GeneratedQueryResultStore from "./generated/GeneratedQueryResultStore"

class QueryResultStore extends GeneratedQueryResultStore {

}

export const queryResultStore = new QueryResultStore()
